var map = {
	"./bear.svg": 61705,
	"./cat.svg": 30045,
	"./cow.svg": 45448,
	"./dog.svg": 97691,
	"./elephant.svg": 59532,
	"./fox.svg": 41810,
	"./frog.svg": 13181,
	"./giraffe.svg": 82581,
	"./horse.svg": 23818,
	"./koala.svg": 96779,
	"./lion.svg": 9733,
	"./monkey.svg": 81072,
	"./otter.svg": 38971,
	"./owl.svg": 95303,
	"./panda.svg": 83185,
	"./penguin.svg": 37765,
	"./pig.svg": 565,
	"./rabbit.svg": 17479,
	"./seal.svg": 61768,
	"./sheep.svg": 65932,
	"./shiba.svg": 98020,
	"./tiger.svg": 96208,
	"./walrus.svg": 69201,
	"./wolf.svg": 10811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16089;